import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-kid-card',
  templateUrl: './kid-card.component.html',
  styleUrls: ['./kid-card.component.scss']
})
export class KidCardComponent implements OnInit {
  private type: string;
  @Input() response;
  @Input() i;
  @Input() j;
  @Output() noDeliver = new EventEmitter();
  @Output() noDeliverReason = new EventEmitter();
  @Output() clicked = new EventEmitter();
  k: number;
  stat: string;
  style: string;
  waiting: string;
  baseuUlr = environment.img_url;
  arrOfStudentNo = [];
  student_image: any;
  student_status;
  userId;
  loggedInUserId;
  // no_of_cols = 3;
  len: any;
  @ViewChild('studentName') studentNameElement!: ElementRef;
  isTextOverflowing = false;

  constructor() { }

  ngOnInit() {
    this.waiting = '10s';
    this.student_status= localStorage.getItem("studentStatus");
    this.loggedInUserId=localStorage.getItem("userId");
    if(this.response[this.i].students[this.j].request_status){
      // const len = this.response[this.i].students[this.j].request.length;
      this.stat = this.response[this.i].students[this.j].request_status.name;
      // to check the logged in user id with the user id from the pusher, if it doesn't match that means that studen with another teacher or supervisor and deliver popup can't be opened  
      switch(this.student_status){
        case "with_teacher":
          this.userId=this.response[this.i].students[this.j].request_status.pivot['teacher_id'];
          break;
          case "with_supervisor":
          this.userId=this.response[this.i].students[this.j].request_status.pivot['supervisor_id'];
          break;
       } 
    }
    else{
      if (this.response[this.i].students[this.j].requests.length !== 0) {
        const len = this.response[this.i].students[this.j].requests.length;
        this.stat = this.response[this.i].students[this.j].requests[len - 1].pivot.status;
      } else {
        this.stat = '';
      }
    }
   
    this.style = 'width:20%';
    this.student_image = `{'background-image':'url(${this.baseuUlr + this.response[this.i].students[this.j].image_path})'}`
  }
  
  ngAfterViewInit() {
    const studentNameEl = this.studentNameElement?.nativeElement;
    const textContentEl = studentNameEl.querySelector('.textContent');
    
    if (textContentEl.scrollWidth > studentNameEl.clientWidth) {
      this.isTextOverflowing = true;
    }
  }
  setStudentName(name) {
    const sname = name.split(' ');
    return sname[0] + ' ' + sname[sname.length - 1];
  }
  studentClicked(){ 
    let observerMode = localStorage.getItem('observer_mode') ? JSON.parse(localStorage.getItem('observer_mode')):false;
    if(observerMode){
      this.noDeliver.emit(true);
      this.noDeliverReason.emit('observer_mode');
      return;
    }
    /* 
    -this conditon to handle different keys from backend,
     as in real time request the api returns the request in array (request)
     while in normal request the api returns the request in array (requests) 
     - the status of student to deliver can't be pending , as pending means the student is with no staff in the flow
     - the ADMIN student status just to pass the condition for now when logged in as school admin until we get approval on how to handle deliver by admin 
     */
    //  || this.stat!='pending' && this.student_status=="ADMIN" && this.userId == this.loggedInUserId 
     if(this.stat!='pending' && this.stat==this.student_status ){
      if(this.response[this.i].students[this.j].requests){
        this.clicked.emit(this.response[this.i].students[this.j].requests[0].id);
      } 
      else{
        this.clicked.emit(this.response[this.i].students[this.j].request[0].id);
      }  
     }
     else{
      if(this.student_status == 'ADMIN'){
        this.noDeliverReason.emit('Admin');
      }
      else if(this.stat == 'with_parent'){
        this.noDeliverReason.emit('parent');
      }
      else if(this.stat != 'with_parent' && this.student_status !='ADMIN' && this.stat =='pending'){
        this.noDeliverReason.emit('pending');
      }
      else if(this.stat != 'with_parent' && this.student_status !='ADMIN' && this.stat !='pending' && this.stat != this.student_status){
        this.noDeliverReason.emit('nopermission');
      }
      this.noDeliver.emit(true);
     }
  }

  // limitCharacters(inputString, limit) {
  //   if (inputString.length <= limit) {
  //     return inputString;
  //   } else {
  //     return inputString.substring(0, limit);
  //   }
  // }

  hasCustomImage(): boolean {
    const imagePath = this.response[this.i]?.students[this.j]?.image_path;
    if (!imagePath) return false;
    
    // Extract just the filename from the path
    const filename = imagePath.split('/').pop();
    return filename !== 'avatar.png';
  }
}
